import { query } from "./dom";

const elements = {
  html: () => query("html"),
  menuButton: () => query(".js-header-menu-button"),
  nav: (type) => query(`.js-header-nav-${type}`),
  profileButton: () => query(".js-header-profile-button"),
  searchButton: () => query(".js-header-search-button"),
  searchDialog: () => query("#search-dialog"),
  searchInput: () => query("#search-input"),
  searchForm: () => query("#search-form"),
  searchResults: () => query("#search-results"),
  searchClose: () => query("#search-close"),
};

const menuOpenAnimationLength = 600;
let toggleTimeout = null;
const isAdmin = window.__CONFIG__.user.isAdmin;

const toggleMenu = (type) => (event) => {
  clearTimeout(toggleTimeout);
  const nav = elements.nav(type);
  const shouldOpen = !nav.classList.contains("header__nav--open");
  if (shouldOpen) {
    nav.removeAttribute("hidden");
    if (type === "menu") {
      elements.html().classList.add("u-no-scroll");
    }
  } else {
    if (type === "menu") {
      elements.html().classList.remove("u-no-scroll");
    }
    toggleTimeout = setTimeout(
      () => (nav.hidden = true),
      menuOpenAnimationLength,
    );
  }
  setTimeout(() => {
    nav.classList.toggle("header__nav--open", shouldOpen);
    if (type === "profile") {
      nav.style.height =
        shouldOpen ?
          isAdmin ? "104px"
          : "72px"
        : "0";
    }
  }, 0);
};

function toggleSearch() {
  const dialog = elements.searchDialog();
  if (dialog.open) {
    dialog.close();
  } else {
    dialog.showModal();
    elements.searchInput().focus();
  }
}

let lastSearchT = 0; // Only ever consider the last search
let searchDebounceTimer = null;

async function executeSearch() {
  const searchT = +new Date();
  lastSearchT = Math.max(lastSearchT, searchT);
  const url = new URL("/_search/", window.location.origin);
  for (const [key, v] of new FormData(elements.searchForm()).entries()) {
    let value = String(v).trim();
    if (value.length) {
      url.searchParams.append(key, value);
    }
  }
  if (!url.searchParams.has("q")) {
    elements.searchResults().innerHTML = "";
    return;
  }
  const resp = await fetch(url);
  if (!resp.ok) return;
  if (searchT < lastSearchT) return;
  const html = await resp.text();
  elements.searchResults().innerHTML = html;
}

function startSearchDebounce() {
  clearTimeout(searchDebounceTimer);
  searchDebounceTimer = setTimeout(executeSearch, 200);
}

function searchDialogClick(event) {
  const searchDialog = elements.searchDialog();
  if (event.target === searchDialog) {
    searchDialog.close();
  }
}

export const setup = () => {
  elements.menuButton().addEventListener("click", toggleMenu("menu"));
  elements.profileButton()?.addEventListener("click", toggleMenu("profile"));
  elements.searchButton()?.addEventListener("click", toggleSearch);
  elements.searchClose()?.addEventListener("click", toggleSearch);
  elements.searchDialog()?.addEventListener("click", searchDialogClick);
  elements.searchInput()?.addEventListener("input", startSearchDebounce);
  elements.searchForm()?.addEventListener("change", startSearchDebounce);
};
